import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { ActivatedRoute,Router  } from '@angular/router';

  @Component({
    selector: 'content-list-division2',
    templateUrl: './a-content-list-division2.component.html',
})
export class AContentListDivision2Component implements OnInit {
    @Input() md: any;
    @Input() eflg: boolean;
    
    dupcheckLists:boolean = false;
    division_1_id : number = null;
    selected_language_id : number = null;
    constructor(
        private commonService: CommonService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.changeLanguage(this.selected_language_id);
    }

    addRow(row:number) : void{
        let sss={
            m_language_id: null,
            title_name: null,
            d_code: "",
        };
        this.md.data.content.splice(row+1, 0, sss); // i番目の次に１レコード追加
        this.changeLanguage(this.selected_language_id);
    }
    delRow(row:number) : void{
        if (this.md.data.content.length==1){
            this.md.data.content=[];
            this.addRow(0);
        }else{
            this.md.data.content.splice(row, 1); // i番目を１レコード削除
        }
        this.changeLanguage(this.selected_language_id);
    }
    upRow(row:number) : void{
        if (row==0){//最初

        }else{
            this.md.data.content.splice(row-1, 2, this.md.data.content[row], this.md.data.content[row-1]);
        }
    }
    downRow(row:number) : void{
        if (row==this.md.data.content.length -1){//最終

        }else{
            this.md.data.content.splice(row, 2, this.md.data.content[row+1], this.md.data.content[row]);
        }
    }
    changeLanguage(selected_language_id):void{
        this.dupcheckLists =  this.commonService.checkDupRecords(this.md.data.content,'m_language_id');
        
    }
}


// WEBPACK FOOTER //
// ./src/app/a2124-ydivision2/a-content-list-division2.component.ts